import { createSelector } from 'reselect';
import { KEY } from '.';
import { GlobalState } from 'store/types';

const getActivityLogState = (state: GlobalState) => state[KEY];

const selectActivityLog = createSelector(getActivityLogState, (state) => state.activityLog);

const selectPending = createSelector(getActivityLogState, (state) => state.pending);

const selectHasMore = createSelector(getActivityLogState, (state) => state.hasMore);

const selectTotalRecords = createSelector(getActivityLogState, (state) => state.totalRecords);

const selectExportData = createSelector(getActivityLogState, (state) => state.export.data);

const selectExportPending = createSelector(getActivityLogState, (state) => state.export.pending);

const selectKioskLatestActivityLog = createSelector(getActivityLogState, (state) => state.latestKioskActivityLog);

export const selectors = {
  selectActivityLog,
  selectPending,
  selectHasMore,
  selectTotalRecords,
  selectExportData,
  selectExportPending,
  selectKioskLatestActivityLog
};
